import { Event2Contact } from "../models/Event";
import EmployeeImage from "./EmployeeImage";

/**
 * Custom properties for employee component. 
 * Can be populated by parent element. 
 */
type EmployeeCardProps = {
    employee       : Event2Contact,
    seminarnumber  : string,
    marginCssClass?: string
}

const EmployeeCard = ({ employee, marginCssClass, seminarnumber }: EmployeeCardProps) => {

    const subject: string = "New enquiry about the conference '" + seminarnumber + "'."

    return (
        <div className="row mb-2">
            <div className="col-12 col-md-4">
                <EmployeeImage imageName={employee.lastName + "_2021"} /> 
            </div>
            <div className="col-12 col-md-8 text-start">
                <label className="fw-bold mb-1">{employee.displayName}</label>
                <p className="mb-1">{employee.jobTitle}</p>
                <p className="mb-1">
                    <i className="bi bi-telephone me-1"></i>
                    {employee.phone}
                </p>
                <a href={"mailto:" + employee.email + "?subject=" + subject}>
                    <i className="bi bi-envelope me-1"></i> Get in contact
                </a>
            </div>
        </div>
    )
}

export default EmployeeCard;